module.exports = __webpack_public_path__ + "img/icon_screen.93eb02bc.svg";